

export default function (item) {
  const link = item.properties.link
  const is_preview = this.$store.getters['designIframe/preview']
  if (is_preview && link && link.type) {
    switch (link.type) {
      case "page":
        if (link.pageID) {
          var metaDataID = this.$store.getters['designIframe/metadata/siteComponents'][link.pageID].properties.metaDataID;
          this.$store.dispatch("designIframe/page/getPage", { metaDataID });
        }
        break;
      case "onpage":
        if (link.pageID) {
          var metaDataID2 = this.$store.getters['designIframe/metadata/siteComponents'][link.pageID].properties.metaDataID;
          this.$store.dispatch("designIframe/page/getPage", { metaDataID2 });
        }
        break;

      case "url":
        if (link.urlIsEnable) {
          if (link.target == '_blank') {
            window.open(link.url);
          }
        }
        break;
      default:


        break;
    }
  }
}

